/*
 * Image Form
 * Description:
 * Multi Image upload form with previews
 * and send form data using Ajax
 *
 * Purpose: Would be just to enable Live Image display to upload via AJAX
 * Inputs (Form, SelectFile, SelectTrigger, PreviewContainer, Multiple, MaxImages, ImagesArrayName)
 * Output
 * - getImages (array, get selected images)
 * - select (open select trigger)
 *
 * @author: Elton Jain
*/
/* global define, require, alert */

define('ImageForm',[
    'jquery',
    'UI'
], function ($, UI, undefined) {
    'use strict';

    // How would you store image stack to access it outside, variable or in input
    // How to handle Class selector

    return function (options) {
        var _self = this,
            _imageQue = [],
            defaults = {
                elForm: '',                 // Form Class or ID
                elFileSelect: '',           // FileSelect element Class or ID
                elSelectTrigger: '',        // Trigger Element if
                elPreviewContainer: '',     // Attachment (thumbs) container
                maxImages: 1,               // Max image allowed (int)
                imageArrayName: 'images',   // If we save in input file array
                useContainerSelf: false,
                onChange: null,             // Callback: On Change
            },
            o = $.extend(defaults, options);
            
        // If multiple images allowed
        o.multiple = o.maxImages >= 2 ? true : false;


        /*
         * Render each file image into a DOM element
         * Return DOM element with image background
         */
        function _renderImage (file, callback) {
            if (typeof FileReader !== 'undefined') {
                var $img = $('<span>'),    // New image element
                    reader = new FileReader();

                reader.onload = function() {
                    $img.css('background-image', 'url(' + reader.result + ')');

                    if(callback) {
                        callback($img, reader.result);
                    }
                };

                reader.readAsDataURL(file);
            }
        }

        /*
         * Toggle display of preview container
         */
        function _updatePreviewContainer ($previewContainer) {
            setTimeout(function () {
                if(_imageQue.length >= 1) {
                    $previewContainer.removeClass('hidden');
                } else {
                    $previewContainer.addClass('hidden');
                }
            }, 400);
        }

        /*
         * Bind events
         */
        function _bindEvents () {
            
            // On FileSelect change
            UI.$b.on('change', o.elForm + ' ' + o.elFileSelect, function () {
                // Add files to queue
                // Render each file and add to preview container
                var $this = $(this),
                    fileCount = this.files.length,
                    $form = $this.parents(o.elForm),
                    $previewContainer = typeof o.elPreviewContainer === 'object' ? o.elPreviewContainer : $form.find(o.elPreviewContainer);
                    // console.log($previewContainer);

                $form.addClass('loading');
                if(this.files.length <= 0) {
                    $form.removeClass('loading');
                }

                $.each(this.files, function (index) {
                    var file = this;
                    if(o.multiple === false) {
                        _imageQue = [];
                    }
                    _renderImage(file, function ($img, url) {
                        if(o.multiple && _imageQue.length < o.maxImages) {
                            _imageQue.push(file);
                            $previewContainer.append($img);
                        } else if(o.multiple === false) {
                            _imageQue.push(file);
                            if(o.useContainerSelf === true) {
                                $previewContainer.css('background-image', 'url(' + url + ')');
                            } else {
                                $previewContainer.html($img);
                            }
                            
                        }
                    });

                    // To determine end of process
                    if(index+1 >= fileCount && o.onChange) {
                        // Delay callback
                        // as images are heavy
                        setTimeout(function () {
                            _updatePreviewContainer($previewContainer);
                            $form.removeClass('loading');
                            if(o.onChange) {
                                o.onChange.call(_self);
                            }
                        }, 200);
                    }

                    // Break on Max Image
                    if(_imageQue.length >= o.maxImages) {
                        return false;
                    }
                });
                $form.removeClass('loading');
            });

            // Trigger FileSelect
            UI.$b.on('click', o.elForm + ' ' + o.elSelectTrigger, function (e) {
                e.preventDefault();
                if(o.multiple && _imageQue.length >= o.maxImages) {
                    alert('You can only select ' + o.maxImages + ' images');
                } else {
                    $(this).parent().find(o.elFileSelect).first().trigger('click');
                    if(o.onTrigger) {
                        o.onTrigger.call(_self);
                    }
                }
            });

            // Remove Selected Image from Stack
            if(!o.useContainerSelf) {
                UI.$b.on('click', o.elForm + ' ' + o.elPreviewContainer + ' > *', function () {
                    
                    if(_imageQue.length > 0) {
                        var $item = $(this),
                            $previewContainer = $item.parent(o.elPreviewContainer),
                            index = $item.index();
                        _imageQue.splice(index, 1);

                        $item.remove();
                        _updatePreviewContainer($previewContainer);
                        
                        if(o.onChange) {
                            o.onChange.call(_self);
                        }
                    }
                });
            }

            // 
        }

        /*
         * Initialize
         */
        function init  () {
            if(!(o.elForm && o.elFileSelect && o.elPreviewContainer)) {
                throw('ImageForm: Invalid arguments!');
            }

            _bindEvents();
        }



        // Public methods

        /*
         * Get ImageQue
         */
        _self.getImages = function () {
            return _imageQue;
        };

        /*
         * Get Image Count or false
         */
        _self.hasImages = function () {
            return _imageQue.length || false;
        };

        /*
         * Reset form
         */
        _self.reset = function () {
            _imageQue = [];
            // var $previewContainer = $(o.elForm).find($.o.previewContainer).html('');
            setTimeout(function () {
                if(o.onChange) {
                    o.onChange.call(_self);
                }
            }, 100);

        };


        init();

        return _self;
    };
});
